import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';

import { MarvColor, MarvColorPrimary } from '@marv/types';

@Component({
  selector: 'marv-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
  imports: [IonIcon]
})
export class MarvTagComponent  implements OnInit {

    @Input({alias : 'color', required : false}) colorTag: MarvColor = MarvColorPrimary;
    @Input({alias : 'icon', required : false}) iconTag: string = '';
    @Input({alias : 'disabled', required : false}) disabledTag: boolean = false;
    @Input({alias : 'showCloseButton', required : false}) showCloseButton: boolean = false;
    @Input({alias : 'size', required : false}) sizeTag: 'big'|'medium'|'small' = 'medium';
    @Input({alias : 'isClickable', required : false}) isClickable: boolean = false;
    @Output() onClickTag = new EventEmitter<any>();
    @Output() onCloseTag = new EventEmitter<any>();
    
    constructor() { }

    ngOnInit() {}
    
    clickTag($event: any){      
        if(this.showCloseButton){
            this.closeTag($event);
        }
        else if(this.isClickable){
            $event.stopPropagation();
            this.onClickTag.emit();
        }
    }

    closeTag($event: any) {
        $event.stopPropagation();
        this.onCloseTag.emit();
    }
}
